import { useTranslation } from 'react-i18next'

const Settings = () => {
  const { t } = useTranslation(['common', 'pages', 'errors', 'forms', 'badges', 'navigation'])

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">{t('pages:settingsHeading')}</h1>
        <p className="text-gray-600 mt-2">{t('pages:settingsSubHeading')}</p>
      </div>

      <div className="space-y-6">
        <div className="card">
          <h2 className="text-xl font-bold mb-4">{t('pages:generalSettings')}</h2>
          <p className="text-gray-600">{t('pages:generalSettingsBody')}</p>
        </div>

        <div className="card">
          <h2 className="text-xl font-bold mb-4">{t('pages:userManagement')}</h2>
          <p className="text-gray-600">{t('pages:userManagementBody')}</p>
        </div>

        <div className="card">
          <h2 className="text-xl font-bold mb-4">{t('pages:apiConfiguration')}</h2>
          <p className="text-gray-600">{t('pages:apiConfigurationBody')}</p>
        </div>
      </div>
    </div>
  )
}

export default Settings
